import React, { Component } from 'react';
import Cleave from 'cleave.js/react';
import Formaters from '../../common/Formaters';
import { Run, RuleRunner } from '../Validation/RuleRunner'
import { emptyRegexMatch } from '../Validation/Rules';
import RegexValidator from '../Validation/RegexValidator';
import Config from "../../config";

const fieldValidations = [
  RuleRunner("hours-0", "", emptyRegexMatch(RegexValidator.timeRange, "L'heure n'est pas au bon format")),
  RuleRunner("hours-1", "", emptyRegexMatch(RegexValidator.timeRange, "L'heure n'est pas au bon format")),
  RuleRunner("hours-2", "", emptyRegexMatch(RegexValidator.timeRange, "L'heure n'est pas au bon format")),
  RuleRunner("hours-3", "", emptyRegexMatch(RegexValidator.timeRange, "L'heure n'est pas au bon format")),
  RuleRunner("hours-4", "", emptyRegexMatch(RegexValidator.timeRange, "L'heure n'est pas au bon format")),
  RuleRunner("hours-5", "", emptyRegexMatch(RegexValidator.timeRange, "L'heure n'est pas au bon format")),
  RuleRunner("hours-6", "", emptyRegexMatch(RegexValidator.timeRange, "L'heure n'est pas au bon format")),
];

export default class BusinessHours extends Component {
  constructor(props) {
   super(props);

    this.state = {
      businessHours: props.businessHours,
      validationErrors: { },
    };

    // Make the onChange event
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    var businessHours = this.state.businessHours;
    const name = event.target.name;

    let key = name.split("-")[0];
    let index = name.split("-")[1];
    
    // If value is equal to on thus the element is a checkbox
    // so we get the checked value
    var value = event.target.value;
    if (value === "on") {
      value = event.target.checked
    }

    // Update the businessHour object
    businessHours[index][key] = value;

    this.setState({
      businessHours: businessHours,
    });

    // Create a new object to check the specific hour
    var hourKey = key + "-" + index;
    var hourToCheck = {
      [hourKey]: this.state.businessHours[index].hours
    }

    var errors = Run(hourToCheck, fieldValidations);
    this.setState({
      validationErrors: errors
    })
    this.props.onError(errors);
  }

  errorFor(field) {
    return this.state.validationErrors[field] || "";
  }

  renderTimeView(day, index) {
    return (
      <span>
        <Cleave name={"hours-" + index} type="text" placeholder="heure" className="textbox margin-left-s" value={day.hours} onChange={this.handleChange}
          options={Formaters.timeRange}
        />
        <span className="form-error margin-left-s">{this.errorFor("hours-" + index)}</span>
      </span>
    );
  }

  renderView(day, index) {
    return (
      <tr className="form-group" key={index}>
        <td>
          <label className="switch margin-left-s">
            <input className={"switch-checkbox switch-checkbox-program-"+Config.program.style} name={"isOpen-" + index} type="checkbox" defaultChecked={day.isOpen} onChange={this.handleChange}/>
            <span className="switch-slider round"></span>
          </label>
        
          <label className="label-big">
            {day.name}
          </label>
        </td>
        <td>
          { day.isOpen ? this.renderTimeView(day, index) : <div></div> }
        </td>
      </tr>
    );
  }

  render() {
    const elements = this.state.businessHours.map(
      (day, index) => this.renderView(day, index)
    );

    return (
      <div>
        <table>
          {elements}
        </table>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/BusinessHours/index.js